export default {
  reopenRejectedDocument: "hrmis/document/reopen",
};
